var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 409,
    height: 199,
    viewBox: "0 0 409 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M193.211 4.51646C168.995 11.0285 149.037 36.7844 140.968 71.9354C138.438 82.9564 137.438 106.459 139 118.155C143.006 148.138 156.288 174.244 174.269 187.481C177.597 189.931 182.253 193 182.253 193L194.753 176C189.743 173.586 178.391 165.256 173.865 158.59C150.933 124.821 153.505 64.6074 179.072 36.7064C186.792 28.2814 194.511 24.1284 204.543 23.0034C208.659 22.5608 212.011 22.4309 215.5 24L225.753 8C226.426 7.98159 211.746 2.93444 205.139 3.00144C201.542 3.03744 196.175 3.71946 193.211 4.51646Z",
    fill: "#1A202C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M220 26.5C225.917 28.945 236.977 40.6184 242.027 50.4354C257.79 81.0734 257.59 121.961 241.528 152.347C236.414 162.022 227.334 171.582 219.792 175.231C216.552 176.799 211.281 178.236 206.777 178.781C202.245 179.33 199 178 199 178L187 195.171C193.973 197.554 206.777 200.772 219.846 196.707C240.275 190.353 258.693 169.197 267.156 142.361C280.023 101.561 273.167 55.8624 249.759 26.4074C244.787 20.1504 232.714 10 230.5 10L220 26.5Z",
    fill: "#1A202C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.214 72L107.636 44L108.156 135.5H136.136V155.5H108.136V195.5H88.136V155.5H59.636C43.961 155.5 31.136 155.243 31.136 154.93C31.136 154.616 34.0949 150.116 37.7109 144.93L44.2849 135.5H88.136L88.214 72Z",
    fill: "#1A202C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.738 75C27.195 116.25 2.97692 151.237 1.91992 152.75L0 155.5L24.636 155.418L108.183 34.5L107.636 0L55.738 75Z",
    fill: "#1A202C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M360.214 72L379.636 44L380.156 135.5H408.136V155.5H380.136V195.5H360.136V155.5H331.636C315.961 155.5 303.136 155.243 303.136 154.93C303.136 154.616 306.095 150.116 309.711 144.93L316.285 135.5H360.136L360.214 72Z",
    fill: "#1A202C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M327.738 75C299.195 116.25 274.977 151.237 273.92 152.75L272 155.5L296.636 155.418L380.183 34.5L379.636 0L327.738 75Z",
    fill: "#1A202C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.8b860321088e04aaba4888b3d0851a5b.svg";
export { ForwardRef as ReactComponent };